import React from "react";
import "./index.css"
import "./css/mainCSS/fonts.css"
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals"

import { Provider } from "react-redux";
import { store } from "./redux/store"

ReactDOM.createRoot(document.getElementById("root")).render(
	<Provider store={store}>
		<App />
	</Provider>
);
reportWebVitals()